<div class="dialog-container">
    <div class="dialog-header">
        <h4 class="dialog-title">
            <i class="fas fa-tags me-2"></i>
            Atribuire Categorii Template
        </h4>
        <button type="button" class="btn-close" (click)="onCancel()" [disabled]="isSubmitting">
        </button>
    </div>

    <div class="dialog-body">
        <!-- Template Info -->
        <div class="alert alert-info mb-3">
            <h6 class="alert-heading">
                <i class="fas fa-file-alt me-1"></i>
                Informații Template
            </h6>
            <div class="row">
                <div class="col-md-8">
                    <strong>Nume:</strong> {{ data.templateName }}<br>
                    <small class="text-muted">ID: {{ data.templateId }} | Tip: {{ data.templateType === 'oficial' ?
                        'Oficial' : 'Cerere' }}</small>
                </div>
                <div class="col-md-4">
                    <div class="text-end">
                        <span class="badge" [class.badge-primary]="data.templateType === 'oficial'"
                            [class.badge-secondary]="data.templateType === 'cerere'">
                            {{ data.templateType === 'oficial' ? 'Document Oficial' : 'Template Cerere' }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Assignment Summary -->
        <div class="assignment-summary mb-3" *ngIf="selectedCategories.length > 0">
            <div class="alert alert-success">
                <i class="fas fa-check-circle me-1"></i>
                <strong>{{ getAssignmentSummary() }}</strong>
            </div>
        </div>

        <!-- Validation Errors -->
        <div *ngIf="validationErrors.length > 0" class="alert alert-danger">
            <h6 class="alert-heading">
                <i class="fas fa-exclamation-triangle me-1"></i>
                Erori de validare
            </h6>
            <ul class="mb-0">
                <li *ngFor="let error of validationErrors">{{ error }}</li>
            </ul>
        </div>

        <!-- Assignment Options -->
        <div class="assignment-options mb-3">
            <div class="row g-3">
                <div class="col-md-6">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" formControlName="replace_existing"
                            (change)="onAssignmentModeChange()" id="replaceSwitch">
                        <label class="form-check-label" for="replaceSwitch">
                            <strong>Înlocuiește categoriile existente</strong>
                        </label>
                    </div>
                    <div class="form-text">
                        <i class="fas fa-info-circle me-1"></i>
                        {{ assignmentMode === 'replace' ? 'Toate categoriile existente vor fi înlocuite' : 'Categoriile
                        vor fi adăugate la cele existente' }}
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" formControlName="set_primary"
                            id="primarySwitch">
                        <label class="form-check-label" for="primarySwitch">
                            <strong>Setează categorie primară</strong>
                        </label>
                    </div>
                    <div class="form-text">
                        <i class="fas fa-info-circle me-1"></i>
                        Categoria primară va fi folosită pentru organizare și raportare
                    </div>
                </div>
            </div>
        </div>

        <!-- Category Selection Methods -->
        <div class="selection-methods mb-3">
            <ul class="nav nav-tabs" id="selectionTabs" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link" [class.active]="!showTreeView" (click)="showTreeView = false"
                        type="button">
                        <i class="fas fa-search me-1"></i>
                        Căutare
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" [class.active]="showTreeView" (click)="toggleTreeView()" type="button">
                        <i class="fas fa-sitemap me-1"></i>
                        Vedere Arbore
                    </button>
                </li>
            </ul>
        </div>

        <!-- Search Method -->
        <div class="selection-content" *ngIf="!showTreeView">
            <div class="search-section mb-3">
                <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Căutați categorii</mat-label>
                    <input type="text" matInput formControlName="category_search"
                        placeholder="Introduceți numele categoriei..." [matAutocomplete]="categoryAuto">
                    <mat-icon matSuffix>search</mat-icon>
                    <mat-autocomplete #categoryAuto="matAutocomplete" [displayWith]="displayCategory"
                        (optionSelected)="onCategorySelected($event.option.value)">
                        <mat-option *ngFor="let category of filteredCategories | async" [value]="category"
                            [disabled]="isCategorySelected(category)">
                            <div class="category-option">
                                <div class="d-flex align-items-center">
                                    <mat-icon class="me-2">{{ getCategoryIcon(category) }}</mat-icon>
                                    <div class="flex-grow-1">
                                        <strong>{{ category.name }}</strong>
                                        <div class="text-muted small" *ngIf="category.description">
                                            {{ category.description }}
                                        </div>
                                        <div class="text-info small">
                                            {{ getCategoryPath(category) }}
                                        </div>
                                    </div>
                                    <div class="selection-status" *ngIf="isCategorySelected(category)">
                                        <mat-icon class="text-success">check_circle</mat-icon>
                                    </div>
                                </div>
                            </div>
                        </mat-option>
                        <mat-option *ngIf="(filteredCategories | async)?.length === 0" [value]="null" disabled>
                            Nu există categorii disponibile
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <!-- Bulk Actions -->
                <div class="bulk-actions mt-2">
                    <button type="button" class="btn btn-outline-primary btn-sm me-2" (click)="selectAllCategories()"
                        [disabled]="availableCategories.length === 0">
                        <i class="fas fa-check-double me-1"></i>
                        Selectează Toate
                    </button>
                    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="clearAllCategories()"
                        [disabled]="selectedCategories.length === 0">
                        <i class="fas fa-times me-1"></i>
                        Curăță Selecția
                    </button>
                </div>
            </div>
        </div>

        <!-- Tree View Method -->
        <div class="selection-content" *ngIf="showTreeView">
            <div class="tree-section">
                <div *ngIf="isLoading" class="text-center py-3">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Se încarcă...</span>
                    </div>
                </div>

                <app-template-category-tree *ngIf="!isLoading && categoryTree.length > 0" [treeData]="categoryTree"
                    [allowSelection]="true" [allowMultiSelection]="true" [showTemplateCount]="false"
                    [showActions]="false" [selectedCategoryIds]="selectedCategoryIds"
                    (categorySelected)="onCategoryTreeSelected($event)"
                    (categoryMultiSelected)="onCategoryTreeMultiSelected($event)">
                </app-template-category-tree>

                <div *ngIf="!isLoading && categoryTree.length === 0" class="text-center py-3 text-muted">
                    <i class="fas fa-folder-open fa-2x mb-2"></i>
                    <p>Nu există categorii disponibile</p>
                </div>
            </div>
        </div>

        <!-- Selected Categories -->
        <div class="selected-categories" *ngIf="selectedCategories.length > 0">
            <h6 class="section-title">
                <i class="fas fa-tags me-1"></i>
                Categorii Selectate ({{ selectedCategories.length }})
            </h6>

            <div class="categories-list">
                <div *ngFor="let category of selectedCategories; trackBy: trackCategory" class="category-chip"
                    [class.primary-category]="isPrimaryCategory(category)">

                    <div class="category-info">
                        <mat-icon class="category-icon">{{ getCategoryIcon(category) }}</mat-icon>
                        <div class="category-details">
                            <strong>{{ category.name }}</strong>
                            <div class="category-path text-muted small">
                                {{ getCategoryPath(category) }}
                            </div>
                        </div>
                    </div>

                    <div class="category-actions">
                        <!-- Primary Category Toggle -->
                        <button *ngIf="setPrimaryValue" type="button" class="btn btn-sm"
                            [class.btn-primary]="isPrimaryCategory(category)"
                            [class.btn-outline-primary]="!isPrimaryCategory(category)"
                            (click)="isPrimaryCategory(category) ? clearPrimaryCategory() : setPrimaryCategory(category)"
                            title="{{ isPrimaryCategory(category) ? 'Elimină ca primară' : 'Setează ca primară' }}">
                            <i class="fas fa-star"></i>
                        </button>

                        <!-- Remove Button -->
                        <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeCategory(category)"
                            title="Elimină categoria">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Primary Category Warning -->
            <div *ngIf="setPrimaryValue && !primaryCategory" class="alert alert-warning mt-2">
                <i class="fas fa-exclamation-triangle me-1"></i>
                Selectați o categorie primară din lista de mai sus.
            </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="selectedCategories.length === 0" class="empty-state text-center py-4">
            <i class="fas fa-tags fa-3x text-muted mb-3"></i>
            <h6 class="text-muted">Nicio categorie selectată</h6>
            <p class="text-muted">Căutați și selectați categoriile pentru acest template.</p>
        </div>
    </div>

    <div class="dialog-footer">
        <div class="d-flex justify-content-between align-items-center">
            <div class="assignment-info text-muted small">
                <i class="fas fa-info-circle me-1"></i>
                {{ hasChanges() ? 'Aveți modificări nesalvate' : 'Fără modificări' }}
            </div>
            <div class="d-flex gap-2">
                <button type="button" class="btn btn-outline-secondary" (click)="onCancel()" [disabled]="isSubmitting">
                    <i class="fas fa-times me-1"></i>
                    Anulează
                </button>
                <button type="button" class="btn btn-success" (click)="onSubmit()"
                    [disabled]="selectedCategories.length === 0 || isSubmitting || !hasChanges()">
                    <div *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status">
                        <span class="visually-hidden">Se salvează...</span>
                    </div>
                    <i *ngIf="!isSubmitting" class="fas fa-save me-1"></i>
                    {{ isSubmitting ? 'Se salvează...' : 'Atribuie Categorii' }}
                </button>
            </div>
        </div>
    </div>
</div>